import { render, staticRenderFns } from "./DashboardCaseInfo.vue?vue&type=template&id=3b89bd32"
import script from "./DashboardCaseInfo.vue?vue&type=script&lang=ts"
export * from "./DashboardCaseInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports